'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _maintenanceAdminForm = require('./maintenance-admin-form.component');

var _maintenanceAdminForm2 = _interopRequireDefault(_maintenanceAdminForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.maintenanceAdminForm', []).component('maintenanceAdminForm', _maintenanceAdminForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/maintenance-admin-form/maintenance-admin-form.module.js